import { render, staticRenderFns } from "./ElectionCategoryEditDialog.vue?vue&type=template&id=2d489838&scoped=true"
import script from "./ElectionCategoryEditDialog.vue?vue&type=script&lang=js"
export * from "./ElectionCategoryEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d489838",
  null
  
)

export default component.exports